import React, { useRef } from "react";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";

const TableReceiptsReport = ({ table, month, owner }) => {
  const tableRef = useRef(null);
  //  // console.log(table);
  //  // console.log(owner);
  const columns = [
    "Q/L",
    "N°",
    "N° Parcela",
    "Cliente",
    "Descrição",
    "Vencimento",
    "Valor",
    "Situação",
    "Data Recebto",
    "Desconto",
    "Juros",
    "Multa",
    "Acréscimos",
    "Honorários",
    "Pago",
    "Fundo Reserva",
    "Obs",
  ];

  if (owner) {
    Object.keys(table.owners).map((idOwner) => {
      const owner = table.owners[idOwner];
      columns.push(`${owner.name} - ${owner.percentage}%`)
      return;
    })
  };

  const columnsMonth = ["Mês/Ano", "Total", "Recebido"];

  return (
    <div style={{ overflowX: 'auto' }}>
      <div className="my-3 d-flex justify-content-center text-center ">
        {month ? (
          <table ref={tableRef} style={{ width: "99%" }}>
            <tbody>
              <tr
              className="fw-bolder"
              style={{
                backgroundColor: "#b8b8b8",
                color: "#2D2D2D",
              }}
            >
              {columnsMonth.map((item, i) => (
                <td
                  key={i}
                  className="border border-white border-1 p-1 text-center"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "9px",
                  }}
                >
                  {item}
                </td>
              ))}
            </tr>
            {Object.keys(table.data).map((itemYear) => {
              const year = table.data[itemYear];
              //              // console.log(year);
              return (
                <>
                  {Object.keys(year.months).map((itemMonth) => {
                    const month = year.months[itemMonth];
                    //                    // console.log(itemMonth);
                    //                    // console.log(month);
                    return (
                      <tr>
                        <td className="border p-1">
                          {itemMonth}/{itemYear}
                        </td>
                        <td className="border p-1">
                          {formatCurrency(month.total_value)}
                        </td>
                        <td className="border p-1">
                          {formatCurrency(month.total_payment_value)}
                        </td>
                      </tr>
                    );
                  })}
                  <tr
                    className="fw-bolder"
                    style={{
                      backgroundColor: "#b8b8b8",
                      color: "#2D2D2D",
                    }}
                  >
                    <td className="border border-white border-1 p-1 text-center">
                      Total do Ano de {itemYear}
                    </td>
                    <td className="border border-white border-1 p-1 text-center">
                      {formatCurrency(year.total_value)}
                    </td>
                    <td className="border border-white border-1 p-1 text-center">
                      {formatCurrency(year.total_payment_value)}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      ) : (
        <table ref={tableRef} style={{ width: "99%" }}>
          <tbody>
            <tr
              className="fw-bolder"
              style={{
                backgroundColor: "#b8b8b8",
                color: "#2D2D2D",
              }}
            >
              {columns.map((item, i) => (
                <td
                  key={i}
                  className="border border-white border-1 p-1 text-center"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "9px",
                  }}
                >
                  {item}
                </td>
              ))}
            </tr>
            {table &&
              Object.keys(table.data).map((index, i) => {
                const parcel = table.data[index];
                return (<tr key={i}>
                  <td className="border p-1">
                    {parcel.block}/{parcel.land}
                  </td>
                  <td className="border p-1">{parcel.id}</td>
                  <td className="border p-1">{parcel.sequence_number}</td>
                  <td className="border p-1" style={{ whiteSpace: 'nowrap' }}>{parcel.client}</td>
                  <td className="border p-1" style={{ whiteSpace: 'nowrap' }}>{parcel.description}</td>
                  <td className="border p-1">{formatDate(parcel.due_date)}</td>
                  <td className="border p-1">{formatCurrency(parcel.value)}</td>
                  <td className="border p-1" style={{ whiteSpace: 'nowrap' }}>
                    {parcel.status === 0 ? "Em Aberto" : "Pago"}
                  </td>
                  <td className="border p-1">
                    {parcel.payment_date ? formatDate(parcel.payment_date) : ""}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.discount ? parcel.discount : 0)}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.daily_interest_rate ? parcel.daily_interest_rate : 0)}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.fine ? parcel.fine : 0)}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.addition ? parcel.addition : 0)}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.honorary ? parcel.honorary : 0)}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(
                      parcel.payment_value ? parcel.payment_value : 0
                    )}
                  </td>
                  <td className="border p-1">
                    {formatCurrency(parcel.reserve_fund_sale)}
                  </td>
                  {owner &&
                    Object.keys(parcel.owners).map((idOwner) => {
                      const owner = parcel.owners[idOwner];
                      return <td className="border p-1">{formatCurrency(owner.transfer_value)}</td>;
                    })}
                  <td className="border p-1">{parcel.obs}</td>
                </tr>
                )
              })}
            <tr className="fw-bolder" style={{ translate: "0px 5px" }}>
              <td colSpan={3}>Total</td>
              <td colSpan={3}></td>
              <td>{formatCurrency(table.total_value)}</td>
              <td colSpan={2}></td>
              <td>{formatCurrency(table.total_discount)}</td>
              <td>{formatCurrency(table.total_daily_interest_rate)}</td>
              <td>{formatCurrency(table.total_fine)}</td>
              <td>{formatCurrency(table.total_addition)}</td>
              <td>{formatCurrency(table.total_honorary)}</td>
              <td>{formatCurrency(table.total_payment)}</td>
              <td>{formatCurrency(table.total_reserve_fund)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
        </div>

  );
};

export default TableReceiptsReport;
